import * as React from 'react';
import { Experiment } from '@cian/experiments/ab';

import * as styles from './SearchTipsContainer.css';
import { SearchTip } from '../../components/SearchTips/SearchTip';
import { IFullTipSchema } from '../../repositories/text-search/entities/tips/FullTipSchema';
import { BX_AUTOCOMPLETE } from 'shared/constants/experiments';
import classNames from 'classnames';

interface ISearchTipsContainerProps {
  tips?: IFullTipSchema[];
  desktopStyle?: boolean;
  isMainPageTips?: boolean;
  isTipsDisabled?: boolean;
  onClick: (tips: IFullTipSchema) => void;
}

export const SearchTipsContainer: React.FC<ISearchTipsContainerProps> = ({
  tips,
  desktopStyle = false,
  isMainPageTips = false,
  isTipsDisabled = false,
  onClick,
}) => {
  return (
    <div>
      <Experiment name={BX_AUTOCOMPLETE} group="A" default>
        <div
          className={classNames(
            styles['gallery-container'],
            isMainPageTips && styles['main-page-style'],
            desktopStyle && styles['desktop-style'],
          )}
        >
          {tips &&
            tips?.length > 0 &&
            tips.map((tip, index) => (
              <SearchTip key={index} tip={tip} onClick={onClick} isTipsDisabled={isTipsDisabled} />
            ))}
        </div>
      </Experiment>

      <Experiment name={BX_AUTOCOMPLETE} group="B">
        <div className={classNames(styles['wrap-container'], desktopStyle && styles['desktop-style'])}>
          {tips &&
            tips?.length > 0 &&
            tips.map((tip, index) => (
              <SearchTip key={index} tip={tip} onClick={onClick} isTipsDisabled={isTipsDisabled} />
            ))}
        </div>
      </Experiment>
    </div>
  );
};
